import { Controller } from '@hotwired/stimulus'

// Reusable controller for showing/hiding elements based on input values
//
// Usage:
//   <div data-controller="toggle" data-toggle-trigger-value="rental">
//     <select data-action="change->toggle#toggle">
//       <option value="by_timeslot">By Timeslot</option>
//       <option value="rental">Rental</option>
//     </select>
//
//     <div data-toggle-target="toggleable" class="d-none">
//       This section will be shown when "rental" is selected
//     </div>
//   </div>
//
// Options:
//   data-toggle-trigger-value: The value that triggers showing the target (required)
//   data-toggle-match-type-value: "exact" (default) or "includes" for matching logic
//
export default class extends Controller {
  static targets = ['toggleable']
  static values = {
    trigger: String, // The value that triggers showing the target
    matchType: {
      // How to match the value: "exact" or "includes"
      type: String,
      default: 'exact',
    },
  }

  connect() {
    this.toggle()
  }

  toggle(event) {
    const triggerElement =
      event?.target ||
      this.element.querySelector(
        'select, input[type="radio"]:checked, input[type="checkbox"], input[type="text"]'
      )
    console.log(triggerElement)

    if (!triggerElement) {
      return
    }

    let currentValue

    // Handle different input types
    if (triggerElement.type === 'checkbox') {
      currentValue = triggerElement.checked ? 'true' : 'false'
    } else if (triggerElement.type === 'radio') {
      const checkedRadio = this.element.querySelector(
        'input[type="radio"]:checked'
      )
      currentValue = checkedRadio ? checkedRadio.value : ''
    } else {
      currentValue = triggerElement.value
    }

    // Determine if we should show or hide based on match type
    const shouldShow = this.shouldShow(currentValue)

    // Toggle all toggleable targets
    this.toggleableTargets.forEach((target) => {
      if (shouldShow) {
        target.classList.remove('d-none')
        this.enableFormInputs(target)
      } else {
        target.classList.add('d-none')
        this.disableFormInputs(target)
      }
    })
  }

  shouldShow(currentValue) {
    if (this.matchTypeValue === 'includes') {
      return currentValue.includes(this.triggerValue)
    } else {
      // Default to exact match
      return currentValue === this.triggerValue
    }
  }

  enableFormInputs(target) {
    const inputs = target.querySelectorAll('input, select, textarea')
    inputs.forEach((input) => (input.disabled = false))
  }

  disableFormInputs(target) {
    const inputs = target.querySelectorAll('input, select, textarea')
    inputs.forEach((input) => (input.disabled = true))
  }
}
